import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

import { styled } from '@mui/material/styles';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 4,
  width: 18,
  height: 18,
  boxShadow: 'none',
  backgroundColor: theme.palette.grey.A100,
  backgroundImage: 'none',
  border: `1px solid ${theme.palette.primary.dark}`,
  '.Mui-focusVisible &': {
    outline: `2px auto ${theme.palette.primary.dark}`,
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.grey.A100,
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    backgroundColor: theme.palette.grey.A100,
  },
}));

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  backgroundImage: 'none',
  '&:before': {
    display: 'block',
    width: 18,
    height: 18,
    backgroundImage:
    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath"
    + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 "
    + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.primary.main,
  },
  'input:disabled ~ &': {
    background: theme.palette.action.disabledBackground,
  },
}));

const PrimaryCheckbox = (props: CheckboxProps) => (
  <Checkbox
    sx={{
      '&:hover': {
        bgcolor: 'transparent',
      },
    }}
    disableRipple
    icon={<BpIcon />}
    checkedIcon={<BpCheckedIcon />}
    color="default"
    {...props}
  />
);

export default PrimaryCheckbox;
